import React, { FC } from 'react';
import { ResizedImage } from '../../../../../common/ResizedImage';
import { getPictureUrl, isSecureFile } from '../../../../../../utils/media-manager-sdk/items';
import { IFileThumbnail } from '../../../../../common/Thumbnails/types';

const WIDTH = 30;
const HEIGHT = 30;

export const Picture: FC<IFileThumbnail> = ({ file, className, params, dataHook }) => (
  <div className={className} data-hook={dataHook}>
    <ResizedImage
      src={getPictureUrl(file, WIDTH, HEIGHT)}
      source={file.source}
      isSecure={isSecureFile(file)}
      width={WIDTH}
      height={HEIGHT}
      params={params}
    />
  </div>
);
